<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light navbar-thaipbs">
    <button type="button"
      class="navbar-toggler"
      aria-label="Toggle navigation"
      @click.stop="onToggleMenu">
      <i class="fas fa-bars"></i>
    </button>
    <a
      slot="navbar-brand"
      class="navbar-brand">
      <img src="@/assets/logo.png" class="logo" />
    </a>
  </nav>
</template>

<script>
export default {
  methods: {
    onToggleMenu() {
      this.$emit('toggleSidebar');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/navbar.scss';

@media (min-width: 991.98px) {
  .navbar {
    display: none;
  }
}
</style>
